import React from 'react';
import { BrTooltip, BrButton, BrIcon } from "@govbr-ds/webcomponents-react";
import './Tooltip.css';

export const Tooltip = ({ iconName = "fa6-solid:info", iconColor = "primary", content, iconSize = "14" }) => {
    return (
        <BrTooltip>
            <BrButton
                slot="trigger"
                emphasis={iconColor}
                shape="circle"
                aria-label="Informação"
                density="small"
                className="br-button"
            >
                <BrIcon icon-name={iconName} height={iconSize} width={iconSize}></BrIcon>
            </BrButton>
            <div slot="content" className="d-flex flex-column align-items-start justify-content-start">
                {content}
            </div>
        </BrTooltip>
    );
};
